module.exports = __webpack_public_path__ + "img/share.2e516b16.jpg";